import { ComponentType, MouseEventHandler } from 'react'

export type Props = {
	id: string
	ReactComponent?: ComponentType<any>
	host: any
	sentryDsn?: string
	onMouseLeave: MouseEventHandler
	onMouseEnter: MouseEventHandler
	__VIEWER_INTERNAL?: { failedInSsr: boolean }
}

export const getStyle = ({ host }: Props) => (host && host.isResponsive ? {} : { height: 'auto' })
